exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_tabBarPanelPanel_37-fMFbjR2jixY9LJqnuNW {\n  position: relative;\n  z-index: 1000000;\n}\n\n.IA_tabBarPanelPanelOverlay_2lZCsnta1s1mhI0V-RNNTy {\n  width: 100%;\n  background-color: #000000;\n  opacity: 0.4;\n  position: absolute;\n}\n\n.IA_tabBarPanelPanelContent_aSV1dW75zmcbX_-tmLDgT {\n  width: 100%;\n  position: absolute;\n  transition: top 200ms ease-out;\n  border-radius: 10px 10px 0px 0px;\n  padding: 20px;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_tabBarPanelPanel": "IA_tabBarPanelPanel_37-fMFbjR2jixY9LJqnuNW",
	"IA_tabBarPanelPanelOverlay": "IA_tabBarPanelPanelOverlay_2lZCsnta1s1mhI0V-RNNTy",
	"IA_tabBarPanelPanelContent": "IA_tabBarPanelPanelContent_aSV1dW75zmcbX_-tmLDgT"
};